import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import { isEmpty, uniq } from "lodash";
import classNames from "classnames";
import { ErrorText } from "../../../components";
import { CombineProductsModal } from "../../../components";
import ImagePlaceholder from "../../../assets/img/img_placeholder.jpg";

export default class OfferModal extends Component {
    constructor() {
        super();
        this.state = this.getInitState();
    }
    componentDidMount() {
        this.setEditModel();
    }

    componentDidUpdate(prevProps) {
        if (this.props.data.id && prevProps.data.id !== this.props.data.id) {
            this.setEditModel();
        }
        if (
            this.props.offerProducts &&
            prevProps.offerProducts !== this.props.offerProducts
        ) {
            this.setEditModel();
        }
    }

    getInitState = () => ({
        form: {
            offerDescription: "",
            imageDescription: "",
            discountBy: 1,
            amount: 0,
            percentage: 0,
            file: "",
            quantity: 0,
            unitType: 1,
            squareFeet: 0,
            pieces: 0,
            maximumAmount: 0,
        },
        errors: {},
        disableSave: true,
        numImages: 0,
        OfferPrice: "A",
        showModal: false,
        products: [],
        productPrice: 0,
        discountprice: 0,
    });

    componentWillUnmount() {
        this.state = this.getInitState();
    }

    setEditModel = () => {
        const { data, offerProducts } = this.props;

        this.setState(
            {
                form: {
                    offerDescription: data.offerDescription || '',
                    imageDescription: data.imageDescription || '',
                    discountBy: data.discountBy || 1,
                    amount: data.amount || 0,
                    percentage: data.percentage || 0,
                    file: data.imageId,
                    quantity: data.quantity || 0,
                    unitType: data.unitType || 1,
                    squareFeet: data.squareFeet || 0,
                    pieces: data.pieces || 0,
                    maximumAmount: data.maximumAmount || 0,
                },
                products: offerProducts,
            },
            () => {
                this.calculateProductPrice();
            }
        );
    };

    onInputChange = (e) => {
        const { name, value, files } = e.target;
        this.setState(
            (state) => ({
                form: {
                    ...state.form,
                    [name]: value,
                    [name]: name === "file" ? files[0] : value,
                },
                errors: {
                    ...state.errors,
                    [name]: "",
                },
            }),
            () => {
                if (name == "percentage" || name == "amount")
                    this.calculateProductPrice();
            }
        );
    };

    onClose = () => {
        this.setState(this.getInitState());
        this.props.onHide();
    };

    onSave = () => {
        // if (!this.validateForm()) return
        const { data, offerType } = this.props;
        const { form, products } = this.state;
        const body = {
            ...form,
            products: uniq(products.map((product) => product.productId.toString())),
            offerType: offerType,
        };
        this.props[data.id ? "editOffer" : "addOffer"](
            data.id ? { ...body, id: data.id } : body
        );
        this.props.onHide();
    };

    validateForm = () => {
        const { form } = this.state;
        const errors = {};

        Object.keys(form).map((key) => {
            if (!form[key]) errors[key] = "Required";
        });

        this.setState({ errors });

        return isEmpty(errors);
    };

    toggleCombineProducts = () => {
        this.setState((state) => ({
            showModal: !state.showModal,
        }));
    };
    onSelectProduct = (product) => {
        const { products } = this.state;
        products.push(product);
        this.calculateProductPrice();

        this.setState((state) => ({
            products,
            errors: {
                ...state.errors,
                products: "",
            },
        }));
        this.toggleCombineProducts();
        // this.props.onAddProducts();
    };
    removeProduct = (product) => {
        const { products } = this.state;
        this.setState({
            products: products.filter((p) => p.productId !== product.productId),
        });
        this.calculateProductPrice();
    };

    calculateProductPrice = () => {
        const { products, form } = this.state;
        let price = products.reduce((accumulator, x) => accumulator + x.price, 0);
        let discountprice =
            form.discountBy == 1
                ? price - form.amount
                : Math.round(price - price * (form.percentage / 100));
        this.setState({
            productPrice: price,
            discountprice: discountprice,
        });
    };

    render() {
        const { show, offerType } = this.props;
        const { form, errors, products, productPrice, discountprice } = this.state;
        return (
            <Modal show={show} onHide={this.onClose} size="xl" aria-labelledby="contained-modal-title-vcenter" centered
                animation={false}>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Add Offer
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    {(offerType === 1 || offerType === 2 || offerType === 3) && (
                        <>
                            <div className="row mt-2">
                                <div className="col">
                                    <div className="bg-secondary mb-2">
                                        <div className="row align-items-center">
                                            {products &&
                                                products.length > 0 &&
                                                products.map((product) => (
                                                    <div key={product.productId} className="col-md-3">
                                                        <div className="bg-white d-flex m-2 p-2">
                                                            {
                                                                <img src={product.productImages.length ? product.productImages[0] :
                                                                    ImagePlaceholder} alt={product.title} width="80px" />
                                                            }
                                                            <div className="flex-1 d-flex align-items-center">
                                                                <p className="ml-2">{product.title}</p>
                                                            </div>
                                                            <div className="center-item">
                                                                <button className="btn btn-danger" onClick={() => this.removeProduct(product)}
                                                                >
                                                                    <i className="fa fa-trash" />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            <div className="col-md-2 mt-3">
                                                {(offerType == 1 ||
                                                    ((offerType == 2 || offerType == 3) &&
                                                        products.length == 0)) && (
                                                        <div className="form-group">
                                                            <button title="Add To Hotlook" className="btn btn-xs btn-primary ml-2"
                                                                onClick={this.toggleCombineProducts}>
                                                                <i className="fa fa-plus" />
                                                            </button>
                                                        </div>
                                                    )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label className={classNames({ "text-danger": errors.offerDescription, })}>
                                                Offer Description
                                            </label>
                                            <input type="text" name="offerDescription" value={form.offerDescription}
                                                onChange={this.onInputChange} placeholder="Enter Offer Description"
                                                className={classNames("form-control", { "is-invalid": errors.offerDescription, })}
                                                maxLength="50" />
                                            <ErrorText error={errors.offerDescription} />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label className={classNames({ "text-danger": errors.imageDescription, })}>
                                                Image Description
                                            </label>
                                            <input type="text" name="imageDescription" value={form.imageDescription}
                                                onChange={this.onInputChange} placeholder="Enter Image Description"
                                                className={classNames("form-control", { "is-invalid": errors.imageDescription, })}
                                                maxLength="50" />
                                            <ErrorText error={errors.imageDescription} />
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        {offerType === 2 && (
                                            <div className="form-group col-md-4">
                                                <label className={classNames({ "text-danger": errors.quantity, })}>
                                                    Add Quantity
                                                </label>
                                                <input type="text" name="quantity" value={form.quantity} onChange={this.onInputChange}
                                                    placeholder="Enter Quantity" className={classNames("form-control", {
                                                        "is-invalid":
                                                            errors.quantity,
                                                    })} maxLength="50" />
                                                <ErrorText error={errors.quantity} />
                                            </div>
                                        )}

                                        {offerType === 3 && (
                                            <>
                                                <div className="form-group col-md-4">
                                                    <label className={classNames({ "text-danger": errors.unitType, })}>
                                                        Select Unit Type (Square Feet/ Pieces)
                                                    </label>
                                                    <select name="unitType" value={form.unitType} onChange={this.onInputChange}
                                                        className={classNames("form-control", { "is-invalid": errors.unitType, })}>
                                                        <option value={1}>Square Feet</option>
                                                        <option value={2}>Pieces</option>
                                                    </select>
                                                    <ErrorText error={errors.unitType} />
                                                </div>
                                                {form.unitType == 1 ? (
                                                    <div className="form-group col-md-2">
                                                        <label className={classNames({ "text-danger": errors.squareFeet, })}>
                                                            Square Feet
                                                        </label>
                                                        <input type="text" name="squareFeet" value={form.squareFeet}
                                                            onChange={this.onInputChange} placeholder="Enter Amount"
                                                            className={classNames("form-control", { "is-invalid": errors.squareFeet, })}
                                                            maxLength="10" />
                                                        <ErrorText error={errors.squareFeet} />
                                                    </div>
                                                ) : (
                                                    <div className="form-group col-md-2">
                                                        <label className={classNames({ "text-danger": errors.pieces, })}>
                                                            Pieces
                                                        </label>
                                                        <input type="text" name="pieces" value={form.pieces} onChange={this.onInputChange}
                                                            placeholder="Enter Percentage" className={classNames("form-control", {
                                                                "is-invalid"
                                                                    : errors.pieces,
                                                            })} maxLength="10" />
                                                        <ErrorText error={errors.pieces} />
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="row mt-2">
                                <div className="col">
                                    <div className="form-row align-items-end">
                                        <div className="form-group col-md-4">
                                            <label className={classNames({ "text-danger": errors.discountBy, })}>
                                                Select Discount Type (Amount/ Percentage)
                                            </label>
                                            <select name="discountBy" value={form.discountBy} onChange={this.onInputChange}
                                                className={classNames("form-control", { "is-invalid": errors.discountBy, })}>
                                                <option value={1}>Amount</option>
                                                <option value={2}>Percentage</option>
                                            </select>
                                            <ErrorText error={errors.discountBy} />
                                        </div>
                                        {form.discountBy == 1 ? (
                                            <div className="form-group col-md-2">
                                                <label className={classNames({ "text-danger": errors.amount, })}>
                                                    Amount
                                                </label>
                                                <input type="text" name="amount" value={form.amount} onChange={this.onInputChange}
                                                    placeholder="Enter Amount" className={classNames("form-control", {
                                                        "is-invalid":
                                                            errors.amount,
                                                    })} maxLength="10" />
                                                <ErrorText error={errors.amount} />
                                            </div>
                                        ) : (
                                            <div className="form-group col-md-2">
                                                <label className={classNames({ "text-danger": errors.percentage, })}>
                                                    Percentage (%)
                                                </label>
                                                <input type="text" name="percentage" value={form.percentage} onChange={this.onInputChange}
                                                    placeholder="Enter Percentage" className={classNames("form-control", {
                                                        "is-invalid":
                                                            errors.percentage,
                                                    })} maxLength="10" />
                                                <ErrorText error={errors.percentage} />
                                            </div>
                                        )}
                                        <div className="form-group col-md-6">
                                            <label className={classNames("mr-2", { "text-danger": errors.file, })}>
                                                Image
                                            </label>
                                            <input ref={(ref) => {
                                                this.fileSelector = ref;
                                            }}
                                                name="file"
                                                type="file"
                                                className="hidden"
                                                onChange={this.onInputChange}
                                            />

                                            <div class="row">
                                                <div className="col-md-4">
                                                    <button className="btn btn-secondary" onClick={() => this.fileSelector.click()}
                                                    >
                                                        {form.file ? "Change File" : "Select Image"}
                                                    </button>
                                                </div>
                                                {form.file &&
                                                    <div class="col-md-3 px-0">
                                                        <img class="img-thumbnail img-fluid" src={(form.file && !(typeof form.file==="string")) ? URL.createObjectURL(form.file) : form.file} />
                                                    </div>}
                                            </div>
                                            <ErrorText error={errors.file} />
                                        </div>
                                    </div>
                                    <div className="row justify-content-around">
                                        <div className="col-md-3">
                                            <label className="font-weight-bold">
                                                Grand Total: {productPrice}
                                            </label>
                                        </div>
                                        <div className="col-md-3">
                                            <label className="font-weight-bold">
                                                Offer Price: {discountprice}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <CombineProductsModal show={this.state.showModal} onHide={this.toggleCombineProducts}
                                onSelect={this.onSelectProduct} />
                        </>
                    )}

                    {offerType === 4 && (
                        <>
                            <div className="form-row ">
                                <div className="form-group col-md-4">
                                    <label className={classNames({ "text-danger": errors.maximumAmount, })}>
                                        Max Amount
                                    </label>
                                    <input name="maximumAmount" type="text" className={classNames("form-control", {
                                        "is-invalid":
                                            errors.maximumAmount,
                                    })} value={form.maximumAmount} onChange={this.onInputChange} />
                                    <ErrorText error={errors.maximumAmount} />
                                </div>
                                <div className="form-group col-md-4">
                                    <label className={classNames({ "text-danger": errors.discountBy })}>
                                        Select Discount Type (Amount/ Percentage)
                                    </label>
                                    <select name="discountBy" value={form.discountBy} onChange={this.onInputChange}
                                        className={classNames("form-control", { "is-invalid": errors.discountBy, })}>
                                        <option value={1}>Amount</option>
                                        <option value={2}>Percentage</option>
                                    </select>
                                    <ErrorText error={errors.discountBy} />
                                </div>
                                {form.discountBy == 1 ? (
                                    <div className="form-group col-md-4">
                                        <label className={classNames({ "text-danger": errors.amount })}>
                                            Amount
                                        </label>
                                        <input type="text" name="amount" value={form.amount} onChange={this.onInputChange}
                                            placeholder="Enter Amount" className={classNames("form-control", {
                                                "is-invalid": errors.amount,
                                            })} maxLength="10" />
                                        <ErrorText error={errors.amount} />
                                    </div>
                                ) : (
                                    <div className="form-group col-md-4">
                                        <label className={classNames({ "text-danger": errors.percentage, })}>
                                            Percentage (%)
                                        </label>
                                        <input type="text" name="percentage" value={form.percentage} onChange={this.onInputChange}
                                            placeholder="Enter Percentage" className={classNames("form-control", {
                                                "is-invalid":
                                                    errors.percentage,
                                            })} maxLength="10" />
                                        <ErrorText error={errors.percentage} />
                                    </div>
                                )}
                            </div>
                            <div className="row justify-content-around">
                                <div className="col-md-3">
                                    <label className="font-weight-bold">
                                        Grand Total: {form.maximumAmount}
                                    </label>
                                </div>
                                <div className="col-md-3">
                                    <label className="font-weight-bold">
                                        Offer Price:{" "}
                                        {form.discountBy == 1
                                            ? form.maximumAmount - form.amount
                                            : form.maximumAmount -
                                            form.maximumAmount * (form.percentage / 100)}
                                    </label>
                                </div>
                            </div>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger" onClick={this.onClose}>
                        Close
                    </button>
                    <button className="btn btn-primary" onClick={this.onSave}>
                        Save
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}